export default function Input({ value, onChange, placeholder, type = "text", error, disabled, ...props }) {
    return (
      <div className="input-wrapper">
        <input 
          value={value} 
          onChange={onChange} 
          placeholder={placeholder} 
          type={type}
          disabled={disabled}
          {...props}
          className={`input ${error ? "input--error" : ""} ${disabled ? "input--disabled" : ""}`} 
        />
        {error && <span className="error-message">{error}</span>}
      </div>
    );
  }